module.exports = __webpack_public_path__ + "static/media/AL_icon.80ad8daf.ico";